var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8077 8.63422V11.1941H19.2381C18.6335 11.1941 18.2495 11.3068 18.0869 11.531C17.8777 11.778 17.7731 12.1267 17.7731 12.5751V14.3946H20.7031L20.3192 17.2576H17.7731V24.5332H14.7384V17.2576H12.1923V14.3946H14.7384V12.3059C14.7384 11.1381 15.0758 10.2067 15.75 9.5101C16.4707 8.85904 17.4012 8.5332 18.5403 8.5332C19.4938 8.5332 20.2496 8.56708 20.8077 8.63422Z",
  fill: "#222222"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1.0332,
  width: 31,
  height: 31,
  rx: 15.5,
  stroke: "#222222"
})));
export default SvgIconFacebook;